import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=58a2fc8a"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a2fc8a')) {
      api.createRecord('58a2fc8a', component.options)
    } else {
      api.reload('58a2fc8a', component.options)
    }
    module.hot.accept("./Tax.vue?vue&type=template&id=58a2fc8a", function () {
      api.rerender('58a2fc8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/islamicFinance/offerToSell/Tax.vue"
export default component.exports